import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { CRUTransportLayer } from '../CRUTransportLayer';
import { GroupOfSitesConverter, jsonConversions } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import { Inject } from '@logio/typescript-ioc';
import api from '../../api';
import logger from '../../logger';
export var GroupOfSitesLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(GroupOfSitesLayer, _CRUTransportLayer);

  function GroupOfSitesLayer() {
    _classCallCheck(this, GroupOfSitesLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupOfSitesLayer).call(this, CONSTANTS.API.ENDPOINTS.GROUP_OF_SITES));
  }

  _createClass(GroupOfSitesLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Filter GroupOfSites by defined filter params
     * @param groupOfSitesIds
     */

  }, {
    key: "findFiltered",
    value: function findFiltered(groupOfSitesIds) {
      var _this = this;

      return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GROUP_OF_SITES_FILTER)).post({
        ids: groupOfSitesIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var groupOfSites = [];
        (response.data.result || []).map(function (groupOfSite) {
          groupOfSites.push(_this.converter.toObject(groupOfSite, jsonConversions));
        });
        return groupOfSites;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Gets GroupOfSites format by defined filter params
     * @param filter
     */

  }, {
    key: "siteFormat",
    value: function siteFormat(filter) {
      return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.GROUP_OF_SITES_FORMAT)).post(filter, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.result || [];
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return GroupOfSitesLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", GroupOfSitesConverter)], GroupOfSitesLayer.prototype, "converter", void 0);